import React from "react";
import "./Stats.scss";
import CountUp from "react-countup";
import VisibilitySensor from "react-visibility-sensor";

function Analytics() {
  return (
    <div id="stats">
      <div className="statGrid">
        <VisibilitySensor partialVisibility>
          {({ isVisible }) => (
            <div>
              <h2>
                {isVisible ? (
                  <CountUp
                    start={0}
                    end={60}
                    suffix="M"
                    duration="1"
                    delay=".4"
                    prefix="+"
                  />
                ) : null}
              </h2>
              <p className="statTexts">Total Checkouts</p>
            </div>
          )}
        </VisibilitySensor>
        <VisibilitySensor partialVisibility>
          {({ isVisible }) => (
            <div>
              <h2>
                {isVisible ? (
                  <CountUp
                    prefix="$"
                    start={0}
                    end={12}
                    suffix="K"
                    duration="1"
                    delay=".4"
                  />
                ) : null}
              </h2>
              <p className="statTexts">Average profit</p>
            </div>
          )}
        </VisibilitySensor>
        <VisibilitySensor partialVisibility>
          {({ isVisible }) => (
            <div>
              <h2>
                {isVisible ? (
                  <CountUp
                    start={0}
                    end={90}
                    suffix="%"
                    duration="1"
                    delay=".4"
                  />
                ) : null}
              </h2>
              <p className="statTexts">Success rate</p>
            </div>
          )}
        </VisibilitySensor>
      </div>
    </div>
  );
}

export default Analytics;
